// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Patient view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...PatientRender }`, [PatientRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const PatientRenderFragment = graphql(`
  fragment PatientRender on Patient @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    active
    name {
      use
      text
      family
      given
      prefix
      suffix
    }
    telecom {
      system
      value
      use
    }
    gender
    birthDate
    deceasedBoolean
    deceasedDateTime
    address {
      use
      type
      text
      line
      city
      district
      state
      postalCode
      country
    }
    maritalStatus {
      text
      coding {
        system
        code
        display
      }
    }
    multipleBirthBoolean
    multipleBirthInteger
    photo {
      contentType
      url
      title
      creation
    }
    contact {
      relationship {
        text
        coding {
          system
          code
          display
        }
      }
      name {
        use
        text
        family
        given
        prefix
        suffix
      }
      telecom {
        system
        value
        use
      }
      address {
        use
        type
        text
        line
        city
        district
        state
        postalCode
        country
      }
      gender
      organization {
        reference
        type
        display
      }
      period {
        start
        end
      }
    }
    communication {
      language {
        text
        coding {
          system
          code
          display
        }
      }
      preferred
    }
    generalPractitioner {
      reference
      type
      display
    }
    managingOrganization {
      reference
      type
      display
    }
    link {
      other {
        reference
        type
        display
      }
      type
    }
  }
`);
